import http from "./http-common";
import Crypto from "./Crypto";
import { getServidorPorAmbiente } from "../utils/Utils";

/**
 * @class ErroresDataService
 * @brief Gestiona las operaciones de acceso a los datos del log de errores.
 */

class ErroresDataService{
    /**
     * @brief Obtiene la lista de todas las acciones registradas en el log de errores.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP con las acciones registradas.
     */
    obtenerTodos() {
        return http.get(`${getServidorPorAmbiente()}/errores/`, { showLoader: false });
    }
    /**
     * @brief Registra una acción en el log de errores.
     *
     * @param data Datos de la acción que se desea registrar.
     * @param key Clave utilizada para realizar la operación de encriptación.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP con el resultado de la operación de registro.
     */
    async registrar(data, key){
      const datosEncriptados = await Crypto.encriptar(data, key);
      return http.post(`${getServidorPorAmbiente()}/errores/`, datosEncriptados);
    }
    /**
     * @brief Obtiene las acciones registradas en el log de errores que coinciden con un filtro específico.
     *
     * @param data Datos del filtro aplicado a la consulta.
     * @param key Clave utilizada para realizar la operación de encriptación.
     *
     * @returns {Promise<AxiosResponse<any>>} Respuesta HTTP con las acciones filtradas.
     */
    async obtenerPorFiltro(data, key){
      const datosEncriptados = await Crypto.encriptar(data, key);
      return http.get(`${getServidorPorAmbiente()}/errores/obtenerPorFiltro`, {
        params: datosEncriptados});
    }
}

/** Variable para exportar */
export default new ErroresDataService();